export function debounce(func, wait, immediate) {
    var timeout;
    return function () {
        var context = this, args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

export function hasBlankOrNullFields(obj) {
    return Object.values(obj).some(value => {
        if (value === null || value === "") return true;
        if (typeof value === "object") return hasBlankOrNullFields(value);
        return false;
    });
}